import { render, staticRenderFns } from "./ParticaStreamBase.vue?vue&type=template&id=1f80e981&"
import script from "./ParticaStreamBase.vue?vue&type=script&lang=ts&"
export * from "./ParticaStreamBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports